
import Image from 'next/image';

import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { SOCIAL_CARD_TYPE, socialCardKeys } from '@/src/constants/socialcard.constant'
import dayjs from 'dayjs';

import { textColors, cardColors } from '@/src/constants/wall.constant';
import ClassNames from '@/src/components/componentHelper/ClassNames';
import ReadMoreReadLess from 'src/components/componentHelper/ReadMoreReadLess'

const CleanReviewCard = ({ cardWidth, cardItem, fontStyle,darkModeEnabled, cardFontColor, cardBackgroundObject, darkCardTheme, ratingColor, quotationColor, linkColor, highlightColor, engagementDisabled, smallSize, refresh, shortenText, isDateTimeDisabled }) => {

  const options = {
    replace: domNode => {
       const attribProps = attributesToProps(domNode.attribs);

       if (domNode.name === 'a') {
          return <a {...attribProps} style={linkColor && linkColor!=='#0b57a8'?{color: linkColor} :darkModeEnabled ? { color: '#6fb0f6' } : { color: '#0b57a8' }}>{domToReact(domNode.children, options)}</a>
       }
       else if(domNode.name === 'b'){
        let bStyle = highlightColor ? { backgroundColor: highlightColor } : { backgroundColor: '#fcf807' };
        if (darkModeEnabled) {
          bStyle.color = '#726c6c';
        }
        return <b style={bStyle}>{domToReact(domNode.children, options)}</b>
     }
    }
 }

    return (
        <div className="mx-auto py-3" style={{maxWidth: "40rem",minWidth:cardWidth }}>
      
    
      <div 
      className="flex flex-col-reverse justify-between w-full p-10 relative border" 
      style={
        {...(cardBackgroundObject?cardBackgroundObject:{}),borderRadius:'0.75rem',maxWidth:'640px',boxShadow:'5px 10px 5px -3px rgb(0 0 0 / 10%), 0px 4px 46px -2px rgb(0 0 0 / 5%)'}
    }
      >
        <div className='absolute' style={{top:'-10px', left: '35px', backgroundSize:'cover'}}>
        <svg
  xmlns="http://www.w3.org/2000/svg"
  width={26}
  height={21}
  viewBox="0 0 29 21"
  fill="none"
>
  <path
    d="M6.91391 21C4.56659 21 2.81678 20.2152 1.66446 18.6455C0.55482 17.0758 0 15.2515 0 13.1727C0 11.2636 0.405445 9.43939 1.21634 7.7C2.0699 5.91818 3.15821 4.3697 4.48124 3.05454C5.84695 1.69697 7.31935 0.678787 8.89845 0L13.3157 3.24545C11.5659 3.96667 9.98676 4.94242 8.57837 6.17273C7.21266 7.36061 6.25239 8.63333 5.69757 9.99091L6.01766 10.1818C6.27373 10.0121 6.55114 9.88485 6.84989 9.8C7.19132 9.71515 7.63944 9.67273 8.19426 9.67273C9.34658 9.67273 10.4776 10.097 11.5872 10.9455C12.7395 11.7939 13.3157 13.1091 13.3157 14.8909C13.3157 16.8848 12.6542 18.4121 11.3311 19.4727C10.0508 20.4909 8.57837 21 6.91391 21ZM22.5982 21C20.2509 21 18.5011 20.2152 17.3488 18.6455C16.2391 17.0758 15.6843 15.2515 15.6843 13.1727C15.6843 11.2636 16.0898 9.43939 16.9007 7.7C17.7542 5.91818 18.8425 4.3697 20.1656 3.05454C21.5313 1.69697 23.0037 0.678787 24.5828 0L29 3.24545C27.2502 3.96667 25.6711 4.94242 24.2627 6.17273C22.897 7.36061 21.9367 8.63333 21.3819 9.99091L21.702 10.1818C21.9581 10.0121 22.2355 9.88485 22.5342 9.8C22.8756 9.71515 23.3238 9.67273 23.8786 9.67273C25.0309 9.67273 26.1619 10.097 27.2715 10.9455C28.4238 11.7939 29 13.1091 29 14.8909C29 16.8848 28.3385 18.4121 27.0155 19.4727C25.7351 20.4909 24.2627 21 22.5982 21Z"
    fill={quotationColor?quotationColor:"#7975f0"}
  />
</svg>


        </div>

   

  <div className="flex flex-col justify-between text-left" >
    <p className={ClassNames("text-lg tweet-content",fontStyle && fontStyle!==''?`font-${fontStyle}`:'')} style={{ color: !darkModeEnabled ? (cardFontColor || textColors.black.primary) : (cardFontColor || textColors.light.primary), fontSize: !smallSize?"1.15em":"1.0em",lineHeight: !smallSize? 1.5: 1.7, marginBottom: (!isDateTimeDisabled && cardItem[socialCardKeys.messageTime] && !cardItem[socialCardKeys.messageMediaImage]) ? 0 : undefined }}>
    {cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!==''?
                  shortenText?
                        <ReadMoreReadLess elementId={cardItem[socialCardKeys.uuid]}  refresh={()=>refresh()} text={cardItem[socialCardKeys.messageContent]} parse={parse} options={options} length={300} readMore={"Read More"} readLess={"Read Less"}/>
                        :
                        parse(cardItem[socialCardKeys.messageContent], options)
                  :
                  null
               }
    </p>

    {
                  cardItem[socialCardKeys.messageMediaImage] ?

                  cardItem[socialCardKeys.socialCardType]===SOCIAL_CARD_TYPE.DISCORD?
                  <div className="mt-2 flex justify-center w-full" style={{width: '100%', position: 'relative'}}>

                  <img className="h-auto w-auto rounded-md" onLoad={()=>refresh()} objectFit="contain" style={{ width: '100%', borderRadius: '10px', objectFit: 'contain' }} src={cardItem[socialCardKeys.messageMediaImage]} alt="Image" />

               </div>
                  :
                  <div className="mt-2 flex justify-center w-full" style={{width: '100%', position: 'relative'}}>

                     <img loading="lazy" className="h-auto w-auto rounded-md" onLoad={()=>refresh()} priority={true} layout="fill" objectFit="contain" style={{ width: '100%', borderRadius: '10px', objectFit: 'contain' }} src={cardItem[socialCardKeys.messageMediaImage]} alt="Image" />

                  </div>
                  :
                  null
          }

    { (!isDateTimeDisabled && cardItem[socialCardKeys.messageTime]) ?
    <div className={ClassNames('mt-3 mb-1 text-xs',fontStyle && fontStyle!==''?`font-${fontStyle}`:'')} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.secondary) } : { color: (cardFontColor || textColors.light.secondary) }}>{dayjs(cardItem[socialCardKeys.messageTime]).locale('en').format('DD MMM YYYY')}</div>
    :
    null
    }

    {

(cardItem[socialCardKeys.starRating] && cardItem[socialCardKeys.starRating]>0) ?
    <ul className="flex justify-center mt-2  ">
       {
         [...Array(Math.min(5,Math.floor(cardItem[socialCardKeys.starRating])))].map((e,i) =>
       <li key={e}>
         <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star" className="w-4 " style={{color:ratingColor?ratingColor:'#f59e0b'}}
           role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
           <path fill="currentColor"
             d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z">
           </path>
         </svg>
       </li>
         )
       }
       {
        (cardItem[socialCardKeys.starRating]%1===0.5) &&
           <li>
           <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star-half-alt"
             className="w-4 " style={{color:ratingColor?ratingColor:'#f59e0b'}} role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 536 512">
             <path fill="currentColor"
               d="M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z">
             </path>
           </svg>
         </li>
       }

     </ul>
     :
     null
  }

    <div className="flex items-center justify-center mt-4">

      
      <span style={{borderRadius:'100px'}} className="inline-flex items-center justify-center text-center uppercase relative flex-shrink-0 align-top w-12 h-12 self-center">
      
        {
                     cardItem[socialCardKeys.authorImage]?
                     <Image
                     src={cardItem[socialCardKeys.authorImage] || `https://ui-avatars.com/api/?name=${encodeURI(cardItem[socialCardKeys.authorName]?cardItem[socialCardKeys.authorName]:'')}&background=d0d0e1&color=47476b&size=48`}
                     className="w-full h-full object-cover"
                     priority={true} 
                     layout="fill"
                     style={{borderRadius:'100px'}}
                     alt=""
                   />
                   :                  
                  <img  src={`https://ui-avatars.com/api/?name=${encodeURI(cardItem[socialCardKeys.authorName]?cardItem[socialCardKeys.authorName]:'')}&background=d0d0e1&color=47476b&size=48`} alt="" className="w-full h-full object-cover" style={{borderRadius:'100px'}}/>
                  }

      </span>

      
      <div className={ClassNames(( (cardItem[socialCardKeys.workTitle] && cardItem[socialCardKeys.workTitle]!=='') || ((cardItem[socialCardKeys.authorTagline] && cardItem[socialCardKeys.authorTagline]!=='') || (cardItem[socialCardKeys.authorUsername] && cardItem[socialCardKeys.authorUsername]!=='') ))?'mt-2':'',fontStyle && fontStyle!==''?`font-${fontStyle}`:'','flex flex-col ml-3 mb-1')}>
        <a className="text-lg font-semibold" href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary), textDecoration: 'none' } : { color: (cardFontColor || textColors.light.primary), textDecoration: 'none' }} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer noopener">{cardItem[socialCardKeys.authorName]}</a>
             
        { (cardItem[socialCardKeys.workTitle] && cardItem[socialCardKeys.workTitle]!=='')  ?
        <a className={!darkModeEnabled ? 'text-gray-600 mt-1 block text-sm' : 'text-gray-300 mt-1 block text-sm'} href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary) } : { color: (cardFontColor || textColors.light.primary) }} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer noopener">{cardItem[socialCardKeys.workTitle]}</a>
        :
          (cardItem[socialCardKeys.authorTagline] && cardItem[socialCardKeys.authorTagline]!=='') ?
          <a className={!darkModeEnabled ? 'text-gray-600 mt-1 block text-sm' : 'text-gray-300 mt-1 block text-sm'} href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary) } : { color: (cardFontColor || textColors.light.primary) }} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer noopener">{cardItem[socialCardKeys.authorTagline]}</a>

            :
              (cardItem[socialCardKeys.authorUsername] && cardItem[socialCardKeys.authorUsername]!=='') ?
              <a className={!darkModeEnabled ? 'text-gray-600 mt-1 block text-sm' : 'text-gray-300 mt-1 block text-sm'} href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary) } : { color: (cardFontColor || textColors.light.primary) }} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer noopener">       
                    {`@${cardItem[socialCardKeys.authorUsername]}`}
                </a>
                :
                null
        }
      </div>
    </div>

   
  </div>
</div>

</div>
    );
};

export default CleanReviewCard;

